import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './settings-model.js';
import Cookies from 'js-cookie';

const defaultHandler = (state = INITIAL_STATE) => state;

const fetchedSettings = (state, { list }) => ({ ...state, list, loading: false });

const setWhatsappLink = (state, { value }) => {
  Cookies.set('whatsapp_link', value, { expires: 7 });
  return {
    ...state,
    whatsappLink: value,
  };
};

const setWhatsappMessage = (state, { value }) => {
  Cookies.set('whatsapp_message', value, { expires: 7 });
  return {
    ...state,
    whatsappMessage: value,
  };
};

const setWhatsappProductMessage = (state, { value }) => {
  Cookies.set('whatsapp_product_message', value, { expires: 7 });
  return {
    ...state,
    whatsappProductMessage: value,
  };
};

export const { Types, Creators } = createActions({
  settingsFetchAsync: [],
  settingsSaveAsync: ['data'],

  settingsSetWhatsappLink: ['value'],
  settingsSetWhatsappMessage: ['value'],
  settingsSetWhatsappProductMessage: ['value'],
  settingsFetched: ['list'],
});

export default createReducer(INITIAL_STATE, {
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.SETTINGS_FETCHED]: fetchedSettings,
  [Types.SETTINGS_SET_WHATSAPP_LINK]: setWhatsappLink,
  [Types.SETTINGS_SET_WHATSAPP_MESSAGE]: setWhatsappMessage,
  [Types.SETTINGS_SET_WHATSAPP_PRODUCT_MESSAGE]: setWhatsappProductMessage,
});
